import React from "react";
import moment from "moment";

import Color from "helpers/Color";
import { Chart } from "components/UI";

function handleBarClick(id, history) {
  history.push(`/radiators/${id}`);
}

// Checks if reading is at most 20 minutes old
function isRecent(reading) {
  const timestamp = moment(parseInt(reading.UTCTimestamp, 10));
  const lowerLimit = moment().subtract(20, "minutes");
  return moment(timestamp).isAfter(lowerLimit);
}

const RadiatorChart = ({ data, history }) => {
  const chartData = data
    .map(radiator => {
      const reading = radiator.lastReading || {};
      const temp = parseInt(reading.radTemp, 10) || 0;

      return {
        id: radiator.id,
        name: `${radiator.room.name} Radiator ${radiator.number} `,
        temp: isRecent(reading) ? temp : 0
      };
    })
    .filter(r => r);

  return (
    <Chart.TemperatureBar
      title="Radiator Temperatures"
      scrollable
      data={chartData}
      onItemClick={id => handleBarClick(id, history)}
      barHeight={60}
      legendWidth={100}
      color={Color.green}
    />
  );
};

export default RadiatorChart;



// WEBPACK FOOTER //
// ./src/components/Radiator/RadiatorChart.jsx